export default "__VITE_ASSET__C1j8rXW5__"